import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-104"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.603 7.225a3.345 3.345 0 0 0-.423.042 4.987 4.987 0 0 0-8.36 0 3.345 3.345 0 0 0-.423-.042 3.397 3.397 0 1 0 1.326 6.524 4.917 4.917 0 0 0 6.554 0 3.397 3.397 0 1 0 1.326-6.524zm0 5.793a2.38 2.38 0 0 1-.935-.19 1 1 0 0 0-1.05.168 3.917 3.917 0 0 1-5.236 0 1 1 0 0 0-1.05-.168 2.397 2.397 0 1 1-.935-4.603 1.369 1.369 0 0 1 .19.02l.108.014a1 1 0 0 0 .961-.444 3.987 3.987 0 0 1 6.688 0 1 1 0 0 0 .961.444l.108-.014a1.369 1.369 0 0 1 .19-.02 2.397 2.397 0 1 1 0 4.793z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M4.008 6.136a1.545 1.545 0 0 1 1.54-1.467.915.915 0 0 1 .108.012l.084.012a1 1 0 0 0 .961-.445 2.74 2.74 0 0 1 4.598 0 1 1 0 0 0 .961.445l.084-.012a.92.92 0 0 1 .108-.012 1.524 1.524 0 0 1 1.455 2.048 3.379 3.379 0 0 1 .86.538A2.484 2.484 0 0 0 12.136 3.7a3.74 3.74 0 0 0-6.27 0 2.508 2.508 0 0 0-.317-.032A2.548 2.548 0 0 0 3 6.216a2.464 2.464 0 0 0 .069.517 1.705 1.705 0 0 1 .94-.597z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }